import Event from './Event';

export const models = {
  Event: Event,
};
